import { render } from "./detailed.vue?vue&type=template&id=39cbbe80&scoped=true"
import script from "./detailed.vue?vue&type=script&lang=js"
export * from "./detailed.vue?vue&type=script&lang=js"

import "./detailed.vue?vue&type=style&index=0&id=39cbbe80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cbbe80"]])

export default __exports__